import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { get, post, put, del } from "../services/apiClient";
import type { Specialist } from "@postnatal-care/shared-types";

export const useSpecialists = (businessId: string) => {
  return useQuery<Specialist[]>({
    queryKey: ["specialists", businessId],
    queryFn: () => get(`/specialists?businessId=${businessId}`),
    enabled: !!businessId,
  });
};

export const useCreateSpecialist = (businessId: string) => {
  const queryClient = useQueryClient();
  return useMutation<
    Specialist,
    Error,
    Omit<Specialist, "id" | "createdAt" | "updatedAt">
  >({
    mutationFn: (data) => post("/specialists", data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["specialists", businessId] });
    },
  });
};

export const useUpdateSpecialist = (businessId: string) => {
  const queryClient = useQueryClient();
  return useMutation<
    Specialist,
    Error,
    { id: string; data: Partial<Specialist> }
  >({
    mutationFn: ({ id, data }) => put(`/specialists/${id}`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["specialists", businessId] });
    },
  });
};

export const useDeleteSpecialist = (businessId: string) => {
  const queryClient = useQueryClient();
  return useMutation<{ success: boolean }, Error, string>({
    mutationFn: (id) => del(`/specialists/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["specialists", businessId] });
    },
  });
};
